import { JobQueue, SystemType } from '@Types/tiling.types';

import { createSelector } from '@reduxjs/toolkit';
import { getValue } from './common.selectors';

export const selectTiling = createSelector(getValue, state => state.tiling);

export const selectJobs = createSelector(selectTiling, state => state.jobs);
export const selectQueues = createSelector(selectTiling, state => state.queues);

const passInSystemType = (_: unknown, systemType: SystemType) => systemType;
export const selectJobBySystemType = createSelector(
	[selectJobs, passInSystemType],
	(jobs, systemType) => jobs[systemType],
);
export const selectQueueBySystemType = createSelector(
	[selectQueues, passInSystemType],
	(queues, systemType) => queues[systemType],
);
export const selectIsQueueBlocked = createSelector(
	selectQueueBySystemType,
	queue => queue === JobQueue.BLOCKED,
);
